import React from 'react'
import "./Online.css"

const Online = () => {
  return (
    <div className='centre'>ONLINE PAGE - THIS PAGE IS UNDER DEVELOPMENT </div>
  )
}

export default Online